<template>
    <div class="input-box-cont">
        <p class="text-center">{{$t(`COMMON.${device.name}`)}}</p>
        <div class="">
            <el-upload
            class="avatar-uploader"
            :action="filestorageURL"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :show-file-list="false"
            >
                <img v-if="device.link" :src="getLink(device.link)" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
        </div>
        <div class="image-parent mt-3" v-if="device.symbol == 'rs1' || device.symbol == 'ds820'">
            <select name="deviceSymbol" v-model="device.symbol" class="form-control symbol mb-0">
                <option value="" default hidden >{{$t('COMMON.chooseDevice')}}</option>
                <option value="rs1">RS1</option>
                <option value="ds820">DS820</option>
            </select>
        </div>
        <div class="image-parent mt-3" v-if="device.symbol == 'advertisement'">
            <el-switch
                v-model="device.active"
                active-color="#67c23a"
                inactive-color="#f56c6c"
                active-text="Active"
                inactive-text="Deactive">
            </el-switch>
        </div>
        <div class="image-parent mt-3" v-if="device.symbol == 'receipt_banner'">
              <el-button @click="removeImage" type="danger">Remove</el-button>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
export default {
    name: 'ShopDevicesFormItem',
    props: {
        device: { 
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            filestorageURL: `${process.env.VUE_APP_LOCATION}/filestorage`
        }
    },
    methods: {
        getLink(link){
            if(link.includes("local.filestorage"))
                return link.replace("local.filestorage", this.filestorageURL)
            else return link
        },
        handleAvatarSuccess(res, file) {
            this.device.link = res.file
        },
        removeImage(){
            this.device.link = ""
        },
        beforeAvatarUpload(file) {
            return new Promise(async (resolve, reject) => {
                let validate = await this.validateImage( file, this.device.symbol) 
                let imagetype = this.imageTypeIsValid(file)
                if(validate && imagetype)
                    resolve(true)
                else reject(false)
            })
        },
        validateImage( imageFile, symbol) {
            return new Promise((resolve, reject) => {

                if(imageFile.size > 3145728){
                    this.$store.commit('addAlert', {
                        title: 'Failed ',
                        type: 'danger',
                        body: 'Image size max 3MB'
                    });
                    resolve(false);
                    return;
                }

                const fReader = new FileReader();
                fReader.readAsDataURL(imageFile);
                    fReader.onload = (event) => {
                        const image = new Image();
                        image.src = event.target.result;
                        setTimeout(() => {
                            if(!this.imageSizeIsValid(image, symbol)) {
                                if(symbol === 'receipt_banner'){
                                    this.$store.commit('addAlert', {
                                        title: 'Failed ',
                                        type: 'danger',
                                        body: 'Image size should be minimum 640x1290px or maximum 660x1310px'
                                    });
                                }else if(symbol === 'advertisement'){
                                    this.$store.commit('addAlert', {
                                        title: 'Failed ',
                                        type: 'danger',
                                        body: 'Image size should be maximum 650x1300px or maximum 1475x2950px'
                                    });
                                } else {
                                    this.$store.commit('addAlert', {
                                        title: 'Failed ',
                                        type: 'danger',
                                        body: 'Image size should be minimum 125x125px or maximum 1250x1250px'
                                    });
                                }
                                
                                resolve(false);
                                return;
                            }
                            resolve(true);
                            return;
                        }, 0);
                    }
                });
        },
        imageSizeIsValid(image, symbol) {
            if(symbol === 'receipt_banner'){
                if((image.width > 640 && image.width < 660) && (image.height > 1290 && image.height < 1310)) {
                    return true;
                } else {
                    return false;
                }
            }

            if(symbol === 'advertisement'){
                if(image.width > 1475 || image.width < 650 || image.height > 2950 || image.height < 1300) {
                    return false;
                } else {
                    return true;
                }
            }

            if(image.width > 1250 || image.width < 125 || image.height > 1250 || image.height < 125) {
                return false;
            } else {
                return true;
            }
        },
        imageTypeIsValid({type}) {
            let result;
            if(type.match(/jpeg|jpg|png/)) {
                result = true;
            } else {
                result = false;
                this.$store.commit('addAlert', {
                    title: 'Failed ',
                    type: 'danger',
                    body: 'Type of image should be jpg or png'
                });
            }
            return result;
        }
    }
}
</script>

<style lang="scss" >
    .input-box-cont {
        display:flex;
        flex-direction: column;
        justify-content: space-between;    

        p {
            font-size: 1.05em;
        }
    }
    .image-parent {
        display: flex;
        justify-content: center;
    }
    .avatar-uploader .el-upload, .el-upload.el-upload--text {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 200px;
        height: 200px;
        line-height: 200px;
        text-align: center;
    }
    .avatar {
        width: 200px;
        display: block;
    }
    div.image-holder {
        width: 50%;
        height: 100%;
        border: dotted 2px black;
        display: flex;
        justify-content: center;
        align-self: stretch;
        min-height: 100px;
        align-items: center;
        &.placeholder {
            border: dotted #ced4da 2px;
        }
        &.invalid.dirty {
            border-color: red;
        }
        img {
            width: 100%;
        }
    }
</style>